$(window).on("load", function() {
	if (window.location.href.indexOf("sort_by=") > -1 && $('body').hasClass('template-collection')) {
      $("html, body").stop().animate({scrollTop: $(".collection-filter").offset().top - 100}, 500);
    }
   
  var className = $('a.btn.return-link').find('p').attr('class');
   $('a.btn.return-link').addClass(className);
 
  
  
});
(function () {
    jQuery(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll > 100) {
            jQuery('#scrollToTop').css({'display': 'flex'})
        } else {
            jQuery('#scrollToTop').css({'display': 'none'})
        }
    });

    jQuery('#scrollToTop').click(function (ev) {
        ev.preventDefault();
        var body = $("html, body");
        body.stop().animate({scrollTop: 0}, 500);
    });
  $('.page-all-brands .anchor a').click(function(e){
  e.preventDefault();
    var e_ID=$(this).attr('href');
    $('html').animate({
        scrollTop: $(e_ID).offset().top - 150
    }, 1000);
  });

})(jQuery);
// $(window).on('load', function(){
//   $.instagramFeed({
//     'username': 'escents_uk',
//     'container': "#instagram-feed2",
//    'display_profile': false,
//                 'display_biography': false,
//     'display_gallery': true,
//     'callback': null,
//     'styling': true,
//     'items': 1,
//     'items_per_row': 1,
//     'margin': 0 
//   });
// });


var userFeed = new Instafeed({
		get: 'user',
		target: "instagram-feed2",
		limit:1,
    	resolution: 'low_resolution',
		accessToken: 'IGQVJVTWhVYXp1eHIzM09Pd0J4YmJoVDhfR1dnRkZAHZATh0VTZAoSm9Sc0ZAkUDY3TVJGTUNfaHM4dDZAMZA2I5ZAXAxMjVqNzBpbUxEdGdLWFJJSFJGSzZABU1lfT0Vab2RKU08tWkV6dzNScTBERlNocnFXeQZDZD'
	});
	userFeed.run();

